<script setup lang="ts">
import Skeleton from '@/shared/ui/Skeleton/index';

withDefaults(defineProps<{ isDetailPage?: boolean }>(), {
  isDetailPage: false,
});

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div
    :class="['journal-card-skeleton', { _mobile: isMobile }, { _detail: isDetailPage }]"
  >
    <Skeleton width="100%" height="180px" />
    <div class="journal-card-skeleton__content">
      <Skeleton width="100%" height="20px" />
      <Skeleton width="140px" height="20px" />
    </div>
    <Skeleton width="185px" height="12px" />
  </div>
</template>

<style lang="less" scoped>
.journal-card-skeleton {
  .flex-column(@size-x3);

  overflow: hidden;
  scroll-snap-align: center;
  height: 250px;
  width: 100%;

  &__content {
    .flex-column(2px);
  }

  &._mobile:not(._detail) {
    min-width: 280px;
    max-width: 280px;
  }
}
</style>
